import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import { PlaygroundContent } from "@/pages/Playground/Playground";
import {
  PlaygroundHeaderProvider,
  usePlaygroundHeaderState,
} from "@/pages/Playground/playground-header-state";
import { TanStackPlaygroundRoutingProvider } from "@/pages/Playground/routing/tanstack-playground-routing";

/**
 * Playground now has one optional-parameter TanStack route so moving between a
 * new chat and a conversation keeps the same route component and page state.
 *
 * Unlike the former catch-all route, this screen is not rendered beneath the
 * legacy React Router FaroRoutes wrapper. Root Faro initialization remains in
 * place, but adding TanStack-specific route instrumentation is intentionally
 * outside this shell-only migration.
 */
export const PlaygroundRouteShell = () => {
  const { t } = useTranslation();
  const headerState = usePlaygroundHeaderState();
  const routeId = headerState?.routeId;
  const currentLabel = headerState?.title || t("sidebar.newChat");
  const breadcrumbs = [
    {
      label: t("sidebar.playground"),
      ...(routeId ? { href: "/playground" } : {}),
    },
    { label: currentLabel, current: true },
  ];

  return (
    <AppShell breadcrumbs={breadcrumbs} contentWidth="full">
      <TanStackPlaygroundRoutingProvider>
        <PlaygroundContent />
      </TanStackPlaygroundRoutingProvider>
    </AppShell>
  );
};

export const PlaygroundRouteView = () => (
  <PlaygroundHeaderProvider>
    <PlaygroundRouteShell />
  </PlaygroundHeaderProvider>
);

const PlaygroundRoute = () => (
  <RouteGuard>
    <PlaygroundRouteView />
  </RouteGuard>
);

export const Route = createFileRoute("/playground/{-$id}")({
  component: PlaygroundRoute,
});
